<div class="viewport" [ngStyle]="getViewportStyle()">
	<router-outlet></router-outlet>
</div>
<img class="blur" src="assets/images/blur.jpg" />


// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/app.component.html